export default "/_next/static/images/review-6c429a480c67d80c3536efe62cee5e35.png";